import { z } from "zod";

export const getArticleProductTypeParamSchema = z.object({
	articleProductTypeId: z.uuid(),
});

export type GetArticleProductTypeParamSchema = z.infer<typeof getArticleProductTypeParamSchema>;
